
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Row, BaseIcon, RoundedIcon } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  TradeOrder,
  ETradeOrderStatus
} from '@/modules/common/services/graphql/server/server.sdk';
import { PriceWeights } from './types';

@Component({
  components: {
    Row,
    BaseIcon,
    RoundedIcon
  }
})
export default class PortabilityInfo extends Vue {
  @Prop({ type: Object, required: true })
  private data!: TradeOrder;

  @Prop({ type: Boolean, required: true })
  private isChangePrice!: boolean;

  private NebraskaColors = NebraskaColors;

  private onClickPrice() {
    if (this.isChangePrice) {
      this.$emit('change-to-price');
    }
  }

  private get executedPrice() {
    return this.data.executedPrice?.formatted || '-';
  }

  private get statusFormatted() {
    return this.data.status.formatted?.toLocaleLowerCase() || '-';
  }

  private get isFilled() {
    return this.data.status.value === ETradeOrderStatus.Filled;
  }

  private get computedStylePrice() {
    if (this.isChangePrice) {
      return PriceWeights.canChangePrice;
    }

    return PriceWeights.cannotChangePrice;
  }
}
